import AddIcon from '@mui/icons-material/Add'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import PersonIcon from '@mui/icons-material/Person'
import { IconButton, Menu, MenuItem, Typography } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const CreateMenu = ({
  onOpenCreateOrganization,
  onOpenCreateDeal,
  onOpenCreateContact,
  onOpenCreateBatchDigital,
  isLoading,
}: {
  onOpenCreateOrganization: any
  onOpenCreateDeal: any
  onOpenCreateContact: any
  onOpenCreateBatchDigital?: any
  isLoading?: any
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const navigate = useNavigate()

  const handleClick = event => {
    setIsOpen(true)
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setIsOpen(false)

    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        // title='Create Menu'
        sx={{
          transition: 'transform 0.2s ease-in-out',
          color: theme => (theme.palette.mode === 'dark' ? 'white' : 'black'),
          '&:hover': {
            backgroundColor: 'transparent',
            transform: 'scale(1.2)',
          },
        }}
        disabled={isLoading}
      >
        <AddIcon
          sx={{
            fontSize: 22,
            color: isOpen ? 'text.highlight' : 'text.primary',
            '&:hover': {
              color: theme => theme.palette.text.highlight,
            },
          }}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }} // Adjust the menu's position
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        slotProps={{
          paper: {
            sx: {
              maxHeight: '50vh', // Limit height for smaller screens
              overflowY: 'auto', // Add scroll for long menus
              minWidth: '225px',
            },
          },
        }}
      >
        <Typography
          sx={{
            px: 2,
            py: 1,
            fontWeight: 600,
            color: 'text.primary  ',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            fontSize: '0.85rem',
            width: '100%',
            bgcolor: 'background.paper',
          }}
        >
          Create
        </Typography>
        <MenuItem
          onClick={() => {
            onOpenCreateOrganization()
            handleClose()
          }}
        >
          <CorporateFareIcon
            sx={{
              color: 'rgb(114, 229, 218)',
            }}
          />
          <Typography sx={{ margin: 1 }}>Organization</Typography>
        </MenuItem>

        <MenuItem
          onClick={() => {
            navigate('/roadmap')
            handleClose()
          }}
        >
          <AttachMoneyIcon
            sx={{
              color: '#fbc11e',
            }}
          />
          <Typography sx={{ margin: 1 }}>Deal</Typography>
        </MenuItem>

        <MenuItem
          onClick={() => {
            onOpenCreateContact()
            handleClose()
          }}
        >
          <PersonIcon
            sx={{
              color: 'rgb(255, 123, 187)',
            }}
          />
          <Typography sx={{ margin: 1 }}>Contact</Typography>
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            onOpenCreativeIntake()
            handleClose()
          }}
        >
          <RocketLaunchIcon
            sx={{
              color: 'rgb(245, 108, 53)',
            }}
          />
          <Typography sx={{ margin: 1 }}>Project Task</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenMarketingForm()
            handleClose()
          }}
        >
          <TaskAltIcon
            sx={{
              color: 'rgb(52, 211, 145)',
            }}
          />
          <Typography sx={{ margin: 1 }}>Create Task</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenCreateBatchDigital()
            handleClose()
          }}
          disabled
        >
          <TaskAltIcon
            sx={{
              color: 'rgb(52, 211, 145)',
            }}
          />
          <Typography sx={{ margin: 1 }}>Create Batch (Digital)</Typography>
        </MenuItem> */}
        {/* <MenuItem
          onClick={() => {
            onOpenCreateBatchDigital()
            handleClose()
            // navigate('/createtasks')
          }}
        >
          <LibraryAddIcon
            sx={{
              color: 'rgb(52, 211, 145)',
            }}
          />
          <Typography sx={{ margin: 1 }}>Task(s)</Typography>
        </MenuItem> */}
      </Menu>
    </>
  )
}

export default CreateMenu
